<template>
  <div>
    <div class="row">
      <div class="col-6">
        <h3>ستون های پنهان</h3>
        <draggable class="list-group border a" :list="list2" @end="onEnd" group="people">
          <div class="list-group-item" v-for="(element, index) in list2" :key="element.id">
            <div class="input-group">
              <input type="text" class="form-control" v-model="element.label" aria-describedby="basic-addon1"
                readonly />
              <div class="input-group-prepend">
                <span class="input-group-text text-danger" id="basic-addon1">{{ index }}
                </span>
              </div>
            </div>
          </div>
        </draggable>
      </div>
      <div class="col-6">
        <h3>ستون های آشکار</h3>
        <draggable class="list-group border a" :list="list1" @end="onEnd" group="people">
          <div class="list-group-item" v-for="(element, index) in list1" :key="element.id">
            <div class="input-group">
              <input type="text" class="form-control" v-model="element.label" aria-describedby="basic-addon2" />
              <div class="input-group-prepend">
                <span class="input-group-text text-success" id="basic-addon2">{{ index }}
                </span>
              </div>
            </div>
          </div>
        </draggable>
      </div>
    </div>
    <hr />
    <div class="row">
      <button id="EditData" class="btn btn-success mr-1" dir="ltr" @click.prevent="EditDeta">
        <span class="mr-2"> ثبت اصلاحات</span>
        <span class="fa fa fa-check"></span>
      </button>
      <button id="btnClose" data-dismiss="modal" class="btn btn-danger mr-1" dir="ltr">
        <span class="mr-2">بستن</span> <span class="fa fa-close"></span>
      </button>
    </div>
  </div>
</template>
<script>
  import draggable from "vuedraggable";

  export default {
    data() {
      return {
        DataAxoisGrid: {
          ArryfildValue: {
            SoftwareId: 2,
            UserId: 1,
            FormName: "frm",
            ShowView: 0,
          },
          Method: "post",
          Action: "ReadGridColumns",
        },
        DataAxiosUpdate: {
          ArryfildValue: {
            Id: null,
            tblSoftwareId: 2,
            tblUserId: 1,
            IsVisible: true,
            IndexCol: 0,
            NameDelxahSoton: "نام سیستم",
            FormName: "frmDastresiDB",
            ColumnName: "Dbname",
          },
          Method: "put",
          Action: "ReadGridColumns/",
          Token: this.$session.get("Token"),
          From: "Body",
        },
        list1: [],
        list2: [],
        listPrimery: [],
        ChengList: [],
        ChengListHide: [],
        model: {
          id: null,
          indexCol: null,
          label: "",
          name: "",
          visibility: null,
          width: null,
        },
      };
    },
    components: {
      draggable,
    },
    methods: {
      //   checkMove:function (evt) {

      //     this.ChengList=evt.relatedContext.list;
      //     console.log(this.ChengList)
      //   },
      //   checkMoveHide:function(evt) {
      //     console.log(evt)
      //   },
      // log: function(evt) {
      //   console.log(evt);
      // },
      onEnd: function () {
        this.ChengList = this.list1;
        this.ChengListHide = this.list2;
      },
      EditDeta: function () {
        try {
          var FormNamed =
            this.$store.state.ComponentInToModal.NorouteFormName != null ?
            this.$store.state.ComponentInToModal.NorouteFormName :
            "frm" + this.$route.name;

          console.log("FORMNAME", FormNamed);
          var Url = this.$ExportUrl();

          var axios = require("axios");
          var data;
          var config;
          if (this.ChengList.length > 0) {
            if (this.ChengListHide.length > 0) {
              for (let j = 0; j < this.ChengListHide.length; j++) {
                this.ChengListHide[j].visibility = false;
              }
              for (let z = 0; z < this.ChengListHide.length; z++) {
                const element = this.ChengListHide[z];
                this.DataAxiosUpdate.ArryfildValue = {
                  Id: element.id,
                  tblSoftwareId: 2,
                  tblUserId: 1,
                  IsVisible: element.visibility,
                  IndexCol: element.indexCol,
                  NameDelxahSoton: element.label,
                  FormName: FormNamed,
                  ColumnName: element.name,
                  ShowView: 0,
                };

                data = JSON.stringify(this.DataAxiosUpdate.ArryfildValue);
                config = {
                  method: this.DataAxiosUpdate.Method,
                  url: Url + this.DataAxiosUpdate.Action + element.id,
                  headers: {
                    "Content-Type": "application/json",
                  },
                  data: data,
                };

                axios(config)
                  .then((res) => {
                    if (res.status == 200) {
                      // console.log(res.data)
                      this.$store.state.renderComponentGrid = false;
                      this.$store.state.renderComponentFilterForm = false;
                      this.$nextTick(() => {
                        this.$store.state.renderComponentGrid = true;
                        this.$store.state.renderComponentFilterForm = true;
                        this.DataAxoisGrid.ArryfildValue = {
                          SoftwareId: 2,
                          UserId: 1,
                          FormName: FormNamed,
                          ShowView: 0,
                        };
                        this.$myAxoisGridColumns(this.DataAxoisGrid, true);
                      });
                    }
                  })
                  .catch(function (error) {
                    console.log(error);
                  });
              }
            }
            for (let i = 0; i < this.ChengList.length; i++) {
              this.ChengList[i].indexCol = i;
            }
            for (let index = 0; index < this.ChengList.length; index++) {
              const element = this.ChengList[index];
              this.DataAxiosUpdate.ArryfildValue = {
                Id: element.id,
                tblSoftwareId: 2,
                tblUserId: 1,
                IsVisible: true,
                IndexCol: element.indexCol,
                NameDelxahSoton: element.label,
                FormName: FormNamed,
                ColumnName: element.name,
                ShowView: 0,
              };

              data = JSON.stringify(this.DataAxiosUpdate.ArryfildValue);
              config = {
                method: this.DataAxiosUpdate.Method,
                url: Url + this.DataAxiosUpdate.Action + element.id,
                headers: {
                  "Content-Type": "application/json",
                },

                data: data,
              };

              axios(config)
                .then((res) => {
                  if (res.status == 200) {
                    // console.log(res.data)
                    this.$store.state.renderComponentGrid = false;
                    this.$store.state.renderComponentFilterForm = false;
                    this.$nextTick(() => {
                      this.$store.state.renderComponentGrid = true;
                      this.$store.state.renderComponentFilterForm = true;
                      this.DataAxoisGrid.ArryfildValue = {
                        SoftwareId: 2,
                        UserId: 1,
                        FormName: FormNamed,
                        ShowView: 0,
                      };
                      this.$myAxoisGridColumns(this.DataAxoisGrid, true);
                    });
                  }
                })
                .catch(function (error) {
                  console.log(error);
                });
            }
          } else {
            if (this.list1 != null) {
              for (let index = 0; index < this.list1.length; index++) {
                const element = this.list1[index];
                this.DataAxiosUpdate.ArryfildValue = {
                  Id: element.id,
                  tblSoftwareId: 2,
                  tblUserId: 1,
                  IsVisible: true,
                  IndexCol: element.indexCol,
                  NameDelxahSoton: element.label,
                  FormName: FormNamed,
                  ColumnName: element.name,
                  ShowView: 0,
                };

                data = JSON.stringify(this.DataAxiosUpdate.ArryfildValue);
                config = {
                  method: this.DataAxiosUpdate.Method,
                  url: Url + this.DataAxiosUpdate.Action + element.id,
                  headers: {
                    "Content-Type": "application/json",
                  },
                  data: data,
                };

                axios(config)
                  .then((res) => {
                    if (res.status == 200) {
                      // console.log(res.data)
                      this.$store.state.renderComponentGrid = false;
                      this.$store.state.renderComponentFilterForm = false;
                      this.$nextTick(() => {
                        this.$store.state.renderComponentGrid = true;
                        this.$store.state.renderComponentFilterForm = true;
                        this.DataAxoisGrid.ArryfildValue = {
                          SoftwareId: 2,
                          UserId: 1,
                          FormName: FormNamed,
                          ShowView: 0,
                        };
                        this.$myAxoisGridColumns(this.DataAxoisGrid, true);
                      });
                    }
                  })
                  .catch(function (error) {
                    console.log(error);
                  });
              }
            }
          }
        } catch (error) {
          console.log(error);
        }
      },
    },

    mounted() {
      this.listPrimery = this.$store.state.columns;
      let listFinal = [];
      let listFinalHide = [];
      for (let index = 0; index < this.listPrimery.length; index++) {
        const element = this.listPrimery[index];
        if (element.visibility == true) {
          listFinal.push(element);
        } else {
          if (
            element.label != "" &&
            element.label != "عملیات ها" &&
            element.name != "row"
          ) {
            listFinalHide.push(element);
          }
        }
      }
      this.list1 = listFinal;
      this.list2 = listFinalHide;
    },
  };
</script>
<style scoped>
  .a {
    cursor: move;
    min-height: 200px;
  }
</style>